const styles = {
    formContainer: {
        minWidth: '280px'
    },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '0 30%',
        '@media (max-width: 767px)': {
            padding: '0',
        },
    },
    inputContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    input: {
        width: '80%',
        minWidth: '300px',
        marginTop: '20px',
    },
    submitButton: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '75px',
        width: '250px',
        minHeight: '50px',
        WebkitTransition: '.5s all',
        transition: '.5s all',
        whiteSpace: 'nowrap',
        border: 'none',
        fontSize: '2rem',
        color: '#fff',
        outline: 'none',
        marginBottom: '20px',
        '@media (max-width: 767px)': {
            fontSize: '1.4rem',
            width: '50vw',
            minHeight: '45px',
        }
    },
    // pcmButton: { backgroundColor: '#d667cd' },
    disabledButton: { backgroundColor: 'rgba(0,0,0,0.2)' },
    buttonText: {
        fontSize: '1.5rem'
    },
    buttonIcon: {
        fontSize: '1.75rem',
        marginLeft: '10%',
    },
    titleText: {
        fontSize: '1.75rem',
        textAlign: 'center',
        fontWeight: 'bold',
        // marginBottom: '20px',
    }
};

export default styles;